/**
 * Client-side constants
 *
 * Note: This mirrors some constants from src/server/config/constants.ts
 * Keep these in sync manually when making changes.
 */

/**
 * Categories that should not be included in budgets (alphabetized)
 * These are system/meta categories that don't represent actual spending
 */
export const NON_BUDGETABLE_CATEGORIES = [
  "Bonus & Windfalls",
  "Credit Card Payment",
  "Income - Other",
  "Interest & Dividends",
  "Salary & Wages",
  "Tax Return",
  "Transfer",
  "Uncategorized",
];

/**
 * Categories that are system-critical and cannot be deleted
 * Only "Uncategorized" is truly protected as it's the system fallback.
 * Users can rename other categories - aliases will handle HybridCategorizer mapping.
 */
export const PROTECTED_CATEGORIES = [
  "Uncategorized",         // System fallback category - cannot be deleted or renamed
];

/**
 * Get categories that can be included in budgets
 */
export function getBudgetableCategories(allCategories: string[]): string[] {
  return allCategories.filter(cat => !NON_BUDGETABLE_CATEGORIES.includes(cat));
}
